import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */


import * as React from 'react';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { tint, shade } from 'polished';
import { generateGradient } from '../assets/styles/utility/gradient';
import { form } from '../assets/styles/utility';
import { generateUUID } from '../helpers/utility';
import FormGroup from './FormGroup';
import { jsx as ___EmotionJSX } from "@emotion/react";

const StylesToggleVariables = theme => ({
  height: theme.height['3xsmall'],

  get width() {
    return this.height * 2;
  },

  buttonSizeOffset: 6,

  get buttonSize() {
    return this.height - this.buttonSizeOffset;
  },

  offset: theme.space.xsmall,
  contrastBorderWidth: 1,
  background: {
    default: tint(0.75, theme.color.dark.base),
    active: theme.color.primary.base
  },
  transition: `all ${theme.timing.base} ${theme.transition.base}`
});

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "xpoamk-Toggle",
  styles: "display:flex;align-items:center;label:Toggle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Toggle = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    name,
    className,
    disabled,
    label,
    noContrast,
    value,
    wrapperProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["name", "className", "disabled", "label", "noContrast", "value", "wrapperProps"]);

  const theme = useTheme(); // Only regenerate this if the name prop changes

  const id = React.useMemo(() => `${name}-${generateUUID()}`, [name]);
  return ___EmotionJSX(FormGroup, wrapperProps, ___EmotionJSX("label", {
    css: [{
      display: 'grid',
      gridTemplateColumns: label && 'auto 1fr',
      gap: label && theme.space.small,
      alignItems: 'start'
    }, disabled && {
      cursor: 'not-allowed',
      pointerEvents: 'none',
      opacity: theme.opacity.base
    }, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"],
    className: clsx('CK__Toggle', className)
  }, ___EmotionJSX("div", {
    css: _ref2
  }, "\u200B", ___EmotionJSX("input", _extends({
    type: "checkbox",
    disabled: disabled,
    name: name,
    id: id,
    value: value,
    ref: ref,
    css: [form.base(theme), {
      appearance: 'none',
      position: 'relative',
      width: StylesToggleVariables(theme).width,
      height: StylesToggleVariables(theme).height,
      borderRadius: theme.borderRadius.rounded,
      background: StylesToggleVariables(theme).background.default,
      cursor: 'pointer',
      transition: StylesToggleVariables(theme).transition,
      '&::after': {
        content: "''",
        position: 'absolute',
        transform: `translate(calc(${StylesToggleVariables(theme).offset}px), -50%)`,
        background: generateGradient({
          start: theme.color.light.base,
          stop: shade(0.075, theme.color.light.base),
          position: 'to bottom right'
        }),
        borderRadius: theme.borderRadius.rounded,
        width: StylesToggleVariables(theme).buttonSize,
        height: StylesToggleVariables(theme).buttonSize,
        top: '50%',
        zIndex: 1,
        transition: StylesToggleVariables(theme).transition,
        boxShadow: theme.boxShadow.base
      },
      '&:checked': {
        background: StylesToggleVariables(theme).background.active,
        '&::after': {
          transform: `translate(calc(200% - ${StylesToggleVariables(theme).offset}px - ${StylesToggleVariables(theme).buttonSizeOffset}px), -50%)`
        }
      }
    }, theme.settings.contrast.enable && theme.settings.contrast.form && !noContrast && {
      '.u-contrast &': {
        boxShadow: `inset 0 0 0 1px ${theme.contrast.base}`,
        backgroundColor: 'transparent',
        '&:checked': {
          backgroundColor: 'transparent'
        }
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;"]
  }, rest))), label && ___EmotionJSX("span", null, label)));
});
export default Toggle;